(() => {
	// Display cents as localized currency. HTML trimmed here due to windows.theme.moneyFormat outputting money value with HTML.
	const formatMoney = (cents) => {
		const html = window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
		const div = document.createElement('div');
		div.innerHTML = html;
		return div.textContent.trim();
	};

	// Read metaobject
	const getDiscount = (section) => {
		const rate = Number(section?.dataset?.discountRate);
		return r = Math.max(0, Math.min(0.99, isFinite(rate) ? rate : 0));
	};

	const getDiscountMultiplier = (section) => 1 - getDiscount(section);

	// Smooth scroll to the next steps title with offset
	const scrollToStepTitle = (step) => {
		const title = step?.querySelector(".Bundles__StepTitle");
		if (!title) return;

		const y = title.getBoundingClientRect().top + window.scrollY - 100;
		window.scrollTo({ top: y, behavior: "smooth" });
	};

	// Retrieve store URL for API request
	const getState = (section) => (section.__bundle ||= { picked: {} });

	const primeElements = (root = document) => {
		root.querySelectorAll(".Bundles__SelectButton").forEach(btn => {
			btn.dataset.defaultLabel ||= btn.textContent.trim();
		});

		root.querySelectorAll('.Bundles__Card').forEach(card => {
			if (!card.querySelector('.Bundles__CardDiscount')) {
				const wrap = document.createElement('div');
				wrap.className = 'Bundles__CardDiscount';
				wrap.setAttribute('aria-live', 'polite');
				wrap.innerHTML = `
		<span class="Bundles__CardPriceOriginal"></span>
		<span class="Bundles__CardPriceDiscounted"></span>
		`;
				card.querySelector('.ProductItem__Info')?.prepend(wrap);
			}
		});

		root.querySelectorAll('.ProductItem__ImageWrapper').forEach(link => {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener');
		});

	};

	// Updating totals
	const updateBundleBar = (section) => {
		const picked = Object.values(getState(section).picked);
		const sum = picked.reduce((n, it) => n + (it?.price || 0), 0);

		const totalEl = section.querySelector(".Bundles__TotalOriginal");
		const discountEl = section.querySelector(".Bundles__TotalDiscounted");
		if (totalEl) totalEl.textContent = sum ? formatMoney(sum) : "—";
		const multiplier = getDiscountMultiplier(section);
		if (discountEl) discountEl.textContent = sum ? formatMoney(Math.round(sum * multiplier)) : "—";

		const bar = section.querySelector(".Bundles__Bar");
		if (bar) bar.classList.toggle("has-picks", picked.length > 0);
	};

	// Force the sticky bar open or closed
	const setBarExpanded = (section, expanded) => {
		const toggle = section.querySelector(".Bundles__BarToggle");
		if (!toggle) return;
		toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
		const barItems = section.querySelector(".Bundles__BarItems");
		if (barItems) barItems.inert = !expanded;
	};

	// Enable add bundle to cart button
	const updateAddToCartState = (section) => {
		const btn = section.querySelector(".Bundles__AddToCart");
		if (!btn) return;
		const allComplete = [...section.querySelectorAll(".Bundles__Step")].every(s => s.classList.contains("is-complete"));
		btn.disabled = !allComplete;
		// Reveal the now-active buy button if the bar was collapsed
		if (allComplete) setBarExpanded(section, true);
	};

	const setStepEditable = (step, editable) => {
		step.classList.toggle("is-active", !!editable);
		step.classList.toggle("is-locked", !editable);
		step.classList.toggle("is-complete", !editable);

		const section = step.closest(".Bundles");
		const helpEl = step.querySelector('.Bundles__StepHelp');
		if (helpEl && section) {
			const stepText = section.dataset.stepText;
			const lockedText = section.dataset.lockedText;
			const completeText = section.dataset.completeText;

			if (step.classList.contains('is-complete')) {
				helpEl.textContent = completeText;
			} else if (editable) {
				helpEl.textContent = stepText;
			} else {
				helpEl.textContent = lockedText;
			}
		}

		if (editable) {
			step.querySelectorAll(".Bundles__Card").forEach(card => {
				card.classList.remove("Bundles__Card--dim", "Bundles__Card--selected");
				const b = card.querySelector(".Bundles__SelectButton");
				if (b) {
					b.disabled = false;
					b.textContent = b.dataset.defaultLabel || b.textContent;
				}
			});

			step.querySelectorAll(".SizeSwatch__Radio:checked").forEach(r => (r.checked = false));
			step.querySelectorAll(".Bundles__SelectArea.is-open").forEach(a => a.classList.remove("is-open"));
		}
		const index = +step.dataset.stepIndex;
		const slot = section?.querySelector(`.Bundles__Slot[data-step-index="${index}"]`);
		if (slot) {
			slot.classList.toggle("Bundles__Slot--locked", !editable);
			slot.classList.toggle("Bundles__Slot--unlocked", editable);
		}

		if (slot) {
			const titleEl = slot.querySelector(".Bundles__SlotTitle");
			if (titleEl) {
				const lockEl = titleEl.querySelector(".Bundles__SlotLock");
				if (lockEl) {
					lockEl.classList.toggle('u-visually-hidden', editable);
				}
			}
		}
		const lockIcon = step.querySelector(".Bundles__SlotLock");
		if (lockIcon) {
			step.classList.toggle("is-locked", !editable);
			step.classList.toggle("is-unlocked", editable);
		}
	};

	// Added to Bundle confirmation message
	const addedBundleMessage = (section, show) => {
		const notice = section.querySelector(".Bundles__Notice");
		if (!notice) return;
		notice.setAttribute("aria-hidden", show ? "false" : "true");

		if (show) notice.querySelector(".Bundles__NoticeReturn")?.focus();

		if (!notice.__wired) {
			notice.querySelector(".Bundles__NoticeClose")?.addEventListener("click", () => notice.setAttribute("aria-hidden", "true"));
			notice.__wired = true;
		}
	};

	// Reset sticky bar slot to original state
	const clearSlot = (section, index) => {
		primeElements(section);
		const slot = section.querySelector(`.Bundles__Slot[data-step-index="${index}"]`);
		if (!slot) return;

		slot.classList.remove("Bundles__Slot--filled");
		slot.style.backgroundImage = "";

		const thumb = slot.querySelector(".Bundles__SlotThumb");
		thumb?.removeAttribute("hidden");

		// Clear variant and prices
		slot.querySelectorAll(".Bundles__SlotVariant, .Bundles__SlotPriceOriginal, .Bundles__SlotPriceDiscounted").forEach(el => el.textContent = "");

		// Restore step title
		const title = slot.querySelector(".Bundles__SlotTitle");
		if (title) {
			const stepLabel = section?.dataset.stepLabel;
			title.textContent = `${stepLabel} ${index + 1}`;
		}
	};

	const isSlotFilled = (section, index) => {
		// Check in-memory state first
		const st = getState(section);
		if (st.picked[index]) return true;
		// If state doesn't show, check element class
		const slot = section.querySelector(`.Bundles__Slot[data-step-index="${index}"]`);
		return slot && slot.classList.contains("Bundles__Slot--filled");
	};

	const findNextUnfilledStep = (section, fromIndex) => {
		const steps = section.querySelectorAll(".Bundles__Step");
		// Find next incomplete step
		for (let i = fromIndex + 1; i < steps.length; i++) {
			if (!isSlotFilled(section, i)) return steps[i];
		}
		// Wrap back to the beginning if none found ahead
		for (let i = 0; i <= fromIndex; i++) {
			if (!isSlotFilled(section, i)) return steps[i];
		}
		return null;
	};

	async function completeStep({ card, step, section, input = null }) {
		// Convert data step index into number
		const index = +step.dataset.stepIndex;

		const variantId = input ? input.dataset.variantId : card.dataset.defaultVariantId;
		const price = Number(input ? input.dataset.price : card.dataset.priceCents) || 0;
		const variantLabel = input ? input.getAttribute('value') : null;

		// Save variant data in the bundle state
		getState(section).picked[index] = { variantId, variantLabel, price };

		// Update bottom bar
		const slot = section.querySelector(`.Bundles__Slot[data-step-index="${index}"]`);
		if (slot) {
			slot.classList.add("Bundles__Slot--filled");

			const titleText = (card.querySelector(".ProductItem__Title")?.innerText || "").trim();

			const slotTitle = slot.querySelector(".Bundles__SlotTitle");
			const slotVariant = slot.querySelector(".Bundles__SlotVariant");
			if (slotTitle) slotTitle.textContent = titleText;
			if (slotVariant) {
				slotVariant.textContent = variantLabel ? `(${variantLabel})` : "";
			}

			let imageUrl = card.dataset.productImage;

			if (imageUrl) {
				slot.style.backgroundImage = `url(${imageUrl}?width=280)`;
				slot.style.backgroundSize = "cover";
				slot.style.backgroundPosition = "center";
			}

			const thumb = slot.querySelector(".Bundles__SlotThumb");
			thumb?.setAttribute("hidden", "");

			const multiplier = getDiscountMultiplier(section);

			const priceOrigEl = slot.querySelector(".Bundles__SlotPriceOriginal");
			const priceDiscEl = slot.querySelector(".Bundles__SlotPriceDiscounted");

			if (priceOrigEl) priceOrigEl.textContent = formatMoney(price);
			if (priceDiscEl) priceDiscEl.textContent = formatMoney(Math.round(price * multiplier));
		}

		// Disable other cards
		step.querySelectorAll(".Bundles__Card").forEach(c => {
			c.classList.add("Bundles__Card--dim");
			c.classList.remove("Bundles__Card--selected");
			const b = c.querySelector(".Bundles__SelectButton");
			if (b) b.disabled = true;
		});
		card.classList.remove("Bundles__Card--dim");
		card.classList.add("Bundles__Card--selected");
		const chosenBtn = card.querySelector(".Bundles__SelectButton");
		if (chosenBtn) {
			const selectedLabel = section?.dataset.selectedLabel;
			chosenBtn.textContent = selectedLabel;
			chosenBtn.disabled = true;
		}

		card.querySelector(".Bundles__SelectArea")?.classList.remove("is-open");
		setStepEditable(step, false);

		// Move user to next step
		const next = findNextUnfilledStep(section, index);
		if (next && next !== step) {
			setStepEditable(next, true);
			next.classList.remove("is-locked");
			scrollToStepTitle(next);
		}

		updateBundleBar(section);
		updateAddToCartState(section);
	}

	function resetBundle(section) {
		// Clear state object
		getState(section).picked = {};

		// Reset slots
		section.querySelectorAll(".Bundles__Slot").forEach((_, i) => clearSlot(section, i));

		// Reset steps
		section.querySelectorAll(".Bundles__Step").forEach((s, i) => setStepEditable(s, i === 0));

		// Reset bottom bar
		const totalEl = section.querySelector(".Bundles__TotalOriginal");
		const discountEl = section.querySelector(".Bundles__TotalDiscounted");
		if (totalEl) totalEl.textContent = "—";
		if (discountEl) discountEl.textContent = "—";

		const atc = section.querySelector(".Bundles__AddToCart");
		if (atc) atc.disabled = true;

		// Reset cards
		section.querySelectorAll('.Bundles__Card--selected, .Bundles__Card--dim').forEach(card => {
			card.classList.remove('Bundles__Card--selected', 'Bundles__Card--dim');
			const button = document.querySelector('.Bundles__SelectButton', card);
			if (button) {
				button.textContent = button.dataset.defaultLabel;
				button.disabled = false;
			}
		});

		// Reset step text 
		const lockedText = section.dataset.lockedText;
		const stepText = section.dataset.stepText;
		section.querySelectorAll(".Bundles__Step").forEach((s, i) => {
			const helpEl = s.querySelector('.Bundles__StepHelp');
			if (helpEl) helpEl.textContent = i === 0 ? stepText : lockedText;
		});

		// Reapply lock icons to all bottom bar slots except first
		section.querySelectorAll(".Bundles__Slot").forEach((slot, i) => {
			const titleEl = slot.querySelector(".Bundles__SlotTitle");
			if (!titleEl) return;

			const existingLock = titleEl.querySelector(".Bundles__SlotLock");
			if (existingLock) existingLock.remove();

			if (i !== 0) {
				const lockSpan = document.createElement("span");
				lockSpan.classList.add("Bundles__SlotLock");
				lockSpan.setAttribute("aria-hidden", "true");
				lockSpan.innerHTML = '<svg class="Icon Icon--lock" viewBox="0 0 24 24"><path d="M12 1a5 5 0 0 0-5 5v3H5v15h14V9h-2V6a5 5 0 0 0-5-5zm-3 8V6a3 3 0 0 1 6 0v3H9zm3 5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3z"></path></svg>';
				titleEl.prepend(lockSpan);
			}
		});

		updateBundleBar(section);
	}

	document.querySelectorAll(".Bundles").forEach((bundlesEl) => {

		const firstSlot = bundlesEl.querySelector('.Bundles__Slot[data-step-index="0"] .Bundles__SlotLock');
		firstSlot.classList.add('u-visually-hidden');

		bundlesEl.addEventListener("click", async (e) => {
			const target = e.target;
			const section = target.closest(".Bundles");
			if (section) primeElements(section);

			const slot = target.closest(".Bundles__Slot");
			if (slot && slot.classList.contains("Bundles__Slot--unlocked")) {
				const section = slot.closest(".Bundles");
				const index = +slot.dataset.stepIndex;
				const step = section.querySelector(`.Bundles__Step[data-step-index="${index}"]`);
				if (step) {
					setStepEditable(step, true);
					scrollToStepTitle(step);
				}
				return;
			}

			// Open size panel for multi variant or just select product for single variant
			const toggle = target.closest('.Bundles__SelectButton[data-toggle="sizes"]');
			if (toggle) {
				const card = toggle.closest(".Bundles__Card");
				const step = toggle.closest(".Bundles__Step");
				if (!section || !step) return;

				const single = toggle.dataset.singleVariant === "true";
				const hasRadios = !!card.querySelector(".SizeSwatch__Radio");

				if (single || !hasRadios) {
					completeStep({ card, step, section });
				} else {
					// Only one size panel open at a time within the section
					const area = toggle.closest(".Bundles__SelectArea");
					section.querySelectorAll(".Bundles__SelectArea.is-open").forEach(a => {
						if (a !== area) a.classList.remove("is-open");
					});

					area.classList.toggle("is-open");

					// Attach one-time click listener only if panel is open
					if (area.classList.contains("is-open")) {
						const handleOutsideClick = (e) => {
							const inArea = e.target.closest(".Bundles__SelectArea");
							const isToggle = e.target.closest('.Bundles__SelectButton[data-toggle="sizes"]');
							if (!inArea && !isToggle) {
								area.classList.remove("is-open");
							}
						};
						document.addEventListener("pointerdown", handleOutsideClick, { once: true });
					}
				}
			}

			const remove = target.closest(".Bundles__SlotRemove") || target.closest(".Bundles__CardRemove");
			if (remove) {
				const section = remove.closest(".Bundles");

				let index;
				let step;

				const slot = remove.closest(".Bundles__Slot");
				if (slot) {
					index = +slot.dataset.stepIndex;
				} else {
					step = remove.closest(".Bundles__Step");
					index = +step.dataset.stepIndex;
				}

				if (!section || isNaN(index)) return;

				delete getState(section).picked[index];
				clearSlot(section, index);

				const steps = section.querySelectorAll(".Bundles__Step");
				step ||= steps[index];
				if (step) { setStepEditable(step, true); }
				scrollToStepTitle(step)

				updateBundleBar(section);
				updateAddToCartState(section);
				return;
			}

			// Reset entire bundle
			if (target?.closest(".Bundles__ResetBtn")) {
				resetBundle(section);
				scrollToStepTitle(section.querySelector(".Bundles__Step"));
				updateAddToCartState(section);
				return;
			}

			// Add bundle to cart
			const add = target.closest(".Bundles__AddToCart");
			if (add) {
				const steps = [...section.querySelectorAll(".Bundles__Step")];
				// Build Shopify cart payload
				const bundleName = section.dataset.bundleName || "Bundle";
				const bundleId = section.dataset.bundleId;
				const timestamp = Date.now();

				const items = steps.map((_, i) => getState(section).picked[i])
					.filter(Boolean)
					.map((p, i) => ({
						id: p.variantId,
						quantity: 1,
						properties: {
							Bundle: bundleName,
							_bundle_id: `${bundleId}_${timestamp}`,
							_bundle_step: i + 1,
						}
					}));

				if (items.length !== steps.length) return;

				// API fetch
				add.disabled = true;
				try {
					const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ items })
					});
					const data = await res.json();

					// Trigger events
					document.dispatchEvent(new CustomEvent("product:added", { detail: data }));
					window.dispatchEvent(new CustomEvent("cart:refresh"));

					// Reset bundle
					resetBundle(section);
					updateAddToCartState(section);
					addedBundleMessage(section, true);
				} catch (err) {
					console.error("Error adding bundle to cart", err);
				} finally {
					add.disabled = false;
				}
			}
		});

		// Click handler for selecting size
		bundlesEl.addEventListener("change", (e) => {
			const radio = e.target.closest(".SizeSwatch__Radio");
			if (!radio) return;
			const card = radio.closest(".Bundles__Card");
			const step = radio.closest(".Bundles__Step");
			const section = radio.closest(".Bundles");
			completeStep({ card, step, section, input: radio });
		});

		// Toggle bundles bar collapse
		const barToggle = bundlesEl.querySelector(".Bundles__BarToggle");
		barToggle?.addEventListener("click", () => {
			const expanded = barToggle.getAttribute("aria-expanded") !== "false";
			setBarExpanded(bundlesEl, !expanded);
		});
	});
})();